import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { FaCircleXmark } from "react-icons/fa6";
import BeatLoader from "react-spinners/BeatLoader";
import { Button, Input } from "../CustomComponents";
import SelectFieldComponent from "../CustomComponents/SelectFieldComponent";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import Toast, { ErrorToast, SuccessToast } from "../../Hooks/useToast";
import {
  useAddCategoryMutation,
  useUpdateCategoryMutation,
} from "../../Data/services/trainingApi";

const UpdateCategoryModal = ({
  handleUpdateModalClose,
  data,
  handleUpdate,
  refetch,
  submitFunction,
  modalName,
  loading
}) => {
  const { handleSubmit, control, setValue } = useForm({});

  const [updateCategory, {isLoading: addloading}] = useUpdateCategoryMutation();
  const [addCategory, {isLoading: editLoading}] = useAddCategoryMutation();
  const updateLoading = addloading || editLoading;

  const [rowId, setRowId] = useState("");
  const [userSlug, setUserSlug] = useState("");
  // const [userName, setUserName] = useState("");
  // const [userEmail, setUserEmail] = useState("");
  // const [password, setPassword] = useState("");

  // const [selectedRole, setSelectedRole] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");

  // const roleList = [
  //   { label: "Admin", value: "admin" },
  //   { label: "Moderator", value: "moderator" },
  //   { label: "Editor", value: "editor" },
  // ];

  const statusList = [
    { label: "Active", value: "active" },
    { label: "Block", value: "block" },
  ];

  const [mounted, setMounted] = React.useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (data) {
      setUserSlug(data.id);
      setValue("name", data.name);
    }
  }, [data, mounted]);

  const handleStatusChange = (value) => {
    // console.log(value);
    setSelectedStatus(value);
  };

  const OnSubmit = async (record) => {
    try {
      const payload = {
        slug: userSlug,
        data: {...record}
      };
      let response;
      if (data) {
        response = await updateCategory(payload);
      } else {
        response = await addCategory(payload);
      }

      if (response?.error?.status === 400) {
        console.log(response?.error?.data?.message);
        ErrorToast(response?.error?.data?.message, "error");
      }

      if (response?.error?.status === 500) {
        ErrorToast(response?.error?.data?.message, "error");
      }

      if (response.data) {
        SuccessToast(response?.data?.message);
        handleUpdateModalClose();
        refetch();
      }
    } catch (error) {
      if (error?.response && error?.response?.data?.message) {
        Toast(error?.response?.data?.message, "error");
      }
    }
  };

  if (!mounted) {
    return;
  }

  return (
    <div>
      <ModalContainer handleClose={handleUpdateModalClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-center w-100 justify-content-between mb-4">
            <p className="fs-4 fw-semibold m-0 black-text">
              {data ? "Update" : "Add"} {modalName ? modalName : "Category"}
            </p>
            <span className="bg-white bg-opacity-75 d-flex p-3 rounded-5">
              <FaCircleXmark
                role="button"
                onClick={handleUpdateModalClose}
                style={{ cursor: "pointer" }}
              />
            </span>
          </div>
          <div className="w-100">
            <p className="text-body-tertiary">{data?.name}</p>
            <Form onSubmit={handleSubmit(submitFunction ? submitFunction : OnSubmit)}>
              <Row>
                <Col md={12}>
                  <p className="m-0 black-text">Category Name</p>
                  <Controller
                    control={control}
                    name="name"
                    rules={{
                      required: "The category Name is required.",
                    }}
                    render={({ field: { onChange, onBlur, value, ref } }) => (
                      <Input
                        type="text"
                        value={value}
                        onChange={onChange}
                        innerRef={ref}
                      />
                    )}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Button
                    classes={`${cssStyles.cardBtn} mt-4 ${
                      updateLoading || loading ? "bg-white-subtle" : ""
                    }`}
                    text={
                      updateLoading || loading? (
                        <BeatLoader size={10} />
                      ) : data ? (
                        "Update"
                      ) : (
                        "Add"
                      )
                    }
                    // onClick={handleSubmit}
                    type="Submit"
                  ></Button>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default UpdateCategoryModal;
